import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import InvoiceList from '../components/invoices/InvoiceList';
import InvoiceForm from '../components/invoices/InvoiceForm';
import InvoiceDetail from '../components/invoices/InvoiceDetail';
import InvoicePreview from '../components/invoices/InvoicePreview'; // Nouveau composant
import { useLocation } from 'react-router-dom';

const InvoiceManagement = () => {
    const [view, setView] = useState('list');
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [showPreview, setShowPreview] = useState(false); // Nouvel état pour l'aperçu PDF
    // BL pour lequel on crée une facture (quand on arrive depuis DeliveryNoteDetails)
    const [createForDeliveryNoteId, setCreateForDeliveryNoteId] = useState(null);

    // Information de l'entreprise (à déplacer vers un fichier de configuration ou context)
    const companyInfo = {
        name: 'SENEGAL SOPLAST SARL',
        address: {
            street: 'Point E, Rue G X Rue de Kolda',
            postalCode: '',
            city: 'Dakar',
            country: 'Sénégal'
        },
        siret: ' +221 33 888 88 88',
        phone1: '+221 33 805 47 50',
        phone2: '+221 78 911 95 27',
    };

    const handleCreateInvoice = () => {
        setCreateForDeliveryNoteId(null);   // création manuelle : pas de pré-sélection
        setSelectedInvoiceId(null);
        setView('form');
    };

    const handleViewInvoice = (invoiceId, edit = false) => {
        setSelectedInvoiceId(invoiceId);
        setEditMode(edit);
        setView('detail');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedInvoiceId(null);
        setEditMode(false);
        setCreateForDeliveryNoteId(null);
    };

    const location = useLocation();
    useEffect(() => {
        const dnId = location.state?.createForDeliveryNoteId;
        if (dnId) {
            // Arrivée depuis le détail d'un BL : ouvrir le form pré-rempli
            setCreateForDeliveryNoteId(dnId);
            setSelectedInvoiceId(null);
            setEditMode(false);
            setView('form');
        } else {
            handleCancel();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    const handleSuccess = () => {
        setView('list');
        setSelectedInvoiceId(null);
        setEditMode(false);
        setCreateForDeliveryNoteId(null);
    };

    // Nouvelle méthode pour ouvrir l'aperçu PDF
    const handleOpenPdfPreview = (invoiceId) => {
        setSelectedInvoiceId(invoiceId);
        setShowPreview(true);
    };

    const handleEditInvoice = () => {
        setEditMode(true);
        setView('detail');
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion de la facturation</h1>
            </div>

            {view === 'list' && (
                <InvoiceList
                    onViewInvoice={handleViewInvoice}
                    onCreateInvoice={handleCreateInvoice}
                    onPreviewInvoice={handleOpenPdfPreview} // Nouvelle prop
                    companyInfo={companyInfo} // Passer les infos de l'entreprise
                />
            )}

            {view === 'form' && (
                <InvoiceForm
                    preselectedDeliveryNoteId={createForDeliveryNoteId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'detail' && (
                <InvoiceDetail
                    invoiceId={selectedInvoiceId}
                    editMode={editMode}
                    onEdit={handleEditInvoice} // <-- ajout ici
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                    onPreviewPdf={handleOpenPdfPreview} // Nouvelle prop pour accéder à l'aperçu PDF depuis le détail
                />
            )}

            {/* Modal de prévisualisation PDF */}
            <InvoicePreview
                invoiceId={selectedInvoiceId}
                show={showPreview}
                onHide={() => setShowPreview(false)}
                companyInfo={companyInfo}
            />
        </Container>
    );
};

export default InvoiceManagement;